module.exports = __webpack_public_path__ + "static/media/blog-bg-cards.4ef849c4.jpg";